export default [
  {
    path: '/mp/miniprogram',
    name: 'miniprogram',
    component: () => import('@/pages/mng/third_account/miniprogram/list/App.vue'),
    meta: {
      title: '微信小程序账号',
      dataUrl: '/miniprogram/indexInfo',
    },
  },
  {
    path: '/mng/weworkAccount/index',
    component: () => import('@/pages/mng/third_account/weworkCombine/App.vue'),
    children: [
      {
        path: '/',
        name: 'account',
        component: () => import('@/pages/mng/third_account/weworkCombine/components/account'),
        children: [
          {
            path: '/',
            name: 'tab-account',
            component: () => import('@/pages/mng/third_account/weworkCombine/components/tab-account'),
            meta: {
              title: '企业微信账号',
            },
          },
          {
              path: 'app',
              name: 'account',
              component: () => import('@/pages/mng/third_account/weworkCombine/components/tab-app'),
              meta: {
                title: '企业微信账号',
              },
          },
        ],
      },
      {
        path: 'sync/:type',
        name: 'syncPage',
        component: () => import('@/pages/mng/third_account/weworkCombine/components/sync-page'),
        meta: {
          title: '企业微信账号',
        },
      },
      {
        path: 'conversation',
        name: 'conversation',
        component: () => import('@/pages/mng/third_account/weworkCombine/components/conversation-page'),
        meta: {
          title: '企业微信账号',
        },
      },
      {
        path: 'instead',
        name: 'instead',
        component: () => import('@/pages/mng/third_account/weworkCombine/components/instead-page'),
        meta: {
          title: '企业微信账号',
        },
      },
      {
        path: 'contact',
        name: 'contact',
        redirect: '/mng/weworkAccount/index',
        component: () => import('@/pages/mng/third_account/weworkCombine/components/sync-page'),
        meta: {
          title: '企业微信账号',
        },
      },
      {
        path: 'step',
        component: () => import('@/pages/mng/third_account/weworkCombine/components/router-container'),
        children: [
          {
              path: '/',
              name: 'steps',
              component: () => import('@/pages/mng/third_account/weworkCombine/components/steps'),
              children: [
                {
                  path: 'install',
                  name: 'step-install',
                  component: () => import('@/pages/mng/third_account/weworkCombine/components/step-install'),
                  meta: {
                    title: '企业微信账号',
                  },
                },
                {
                  path: 'auth',
                  name: 'step-auth',
                  component: () => import('@/pages/mng/third_account/weworkCombine/components/step-auth'),
                  meta: {
                    title: '企业微信账号',
                  },
                },
              ],
          },
        ],
      },
      {
        path: 'agentAssistance',
        name: 'weworkAccount',
        component: () => import('@/pages/mng/third_account/weworkCombine/components/agent-assistance/src/agent-assistance.vue'),
        meta: {
          title: '企业微信账号',
        },
      },
    ],
  },
  {
    path: '/mp/accountInfo',
    name: 'accountInfo',
    component: () => import('@/pages/mng/third_account/accountInfo/App.vue'),
    meta: {
      title: '公众号账号',
    },
  },
];
